// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// json
import Config from '../../config.json';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let i18n = {};
let i18nJson = {};
let fonts = {};
let clientConfig = {};

const notification = $('notification');

let isInit = true;
let usedApiPath = '';
let usedRequestMethod = 'POST';

let mapVersion = -1;

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Xhr {

    constructor() {}

    init(globalStore, globalI18n, globalFonts, globalClientConfig) {
        log('xhr init');

        // global objects
        store = globalStore;
        i18n = globalI18n;
        i18nJson = i18n.getCurrentJson();
        fonts = globalFonts;
        clientConfig = globalClientConfig;

        checkUri();
    }

    saveStoredData() {
        saveStoredData();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------
function checkUri() {
    const mapQueryStr = window.location.hash.replace('#', '');
    let initMapId = (mapQueryStr.match(/map_id=(\d+)/) || ['', ''])[1];
    let initClientSlug = (mapQueryStr.match(/client_slug=([^$,]+)/) || ['', ''])[1];

    // if new map was requested
    if(initMapId.length === 0) {
        initMapId = -1;
    } else {
        initMapId = parseInt(initMapId);
    }

    initRequest(initClientSlug, initMapId, 'get-client-config-data');
    initRequest(initClientSlug, initMapId, 'get-client-fonts-data');
    initRequest(initClientSlug, initMapId, 'get-client-map-data');
}

function initRequest(initClientSlug, initMapId, type) {
    let data = {};
    usedApiPath = Config.production.apiPath;
    usedRequestMethod = 'POST';

    // map data
    if(type === 'get-client-map-data') {

        if(isDevelopment() === true) {
            usedApiPath = Config.development.apiPath + '/test-node-to-node-navigation.json';
            usedRequestMethod = 'GET';
        }

        data = {
            clientSlug: initClientSlug,
            mapId: initMapId,
            mapVersion: mapVersion
        };

    // fonts data
    } else if(type === 'get-client-fonts-data') {

        if(isDevelopment() === true) {
            usedApiPath = Config.development.apiPath + '/test-client-fonts.json';
            usedRequestMethod = 'GET';
        }

        data = {
            clientSlug: initClientSlug,
            mapId: initMapId,
            getClientFonts: 'all'
        };

    // client configuration data
    } else if(type === 'get-client-config-data') {

        if(isDevelopment() === true) {
            usedApiPath = Config.development.apiPath + '/test-client-config.json';
            usedRequestMethod = 'GET';
        }

        data = {
            clientSlug: initClientSlug,
            mapId: initMapId,
            getClientConfig: 'all'
        };
    }

    xhr(data);
}

function saveStoredData() {
    // console.log(store.get().toJS());

    if(isDevelopment() === false) {
        const data = {
            clientSlug: store.get().map.owner,
            mapId: store.get().map.id,
            mapVersion: mapVersion,
            storedData: JSON.stringify(store.get().toJS())
        };
        xhr(data);

        // Query elements indicating a change made to the map
        // and add a class to change their state.
        let $changeIndicators = window.parent.$('.js-editorChange');
        $changeIndicators.addClass('has-changed');
    }
}

function response(msg) {
    if(msg.state === 'success') {

        if(isInit === true) {

            // type map state undefined = new map
            if(typeof msg.data.map.state === 'undefined') {
                store.get().map.set({
                    owner: msg.data.map.owner,
                    id: msg.data.map.id
                });

                // add map id as hash
                window.location.hash = [
                    'client_slug=' + msg.data.map.owner,
                    'map_id=' + msg.data.map.id
                ].join(',');

            // add existing map to store
            } else {
                log('add existing map to store');
                log(msg.data);
                if (msg.data.hasOwnProperty('design')) {
                    store.get().design.set(msg.data.design);
                }
                store.get().map.set(msg.data.map);
                store.get().nodes.set(msg.data.nodes);
                store.get().edges.set(msg.data.edges);
            }

            // trigger event
            $(document).trigger('initMapDataEvent');
            isInit = false;
        }

        // set current map version
        // --> take care of multiple users editing
        mapVersion = msg.data.map.version;

    } else if(msg.state === 'success-get-client-fonts') {
        fonts.set(msg.fonts);

    } else if(msg.state === 'error-get-client-fonts') {
        // notification.find('span').text('Schriften konnten nicht geladen werden');
        // notification.removeClass('hide');
        // errorlog('Schriften konnten nicht geladen werden');
        if(!alert(i18nJson.notifications.error.getClientFonts)) {
            window.location.reload(true);
        }

    } else if(msg.state === 'success-get-client-config') {
        clientConfig.set(msg.clientConfig);

    } else if(msg.state === 'error-get-client-config') {
        // notification.find('span').text('Kundendaten konnten nicht geladen werden');
        // notification.removeClass('hide');
        // errorlog('Kundendaten konnten nicht geladen werden');
        alert(i18nJson.notifications.error.getClientConfig);

    } else if(msg.state === 'error-map-version-outdated') {
        // notification.find('span').text('Es existiert eine neuere Map. Bitte laden die Sie Seite neu.');
        // notification.removeClass('hide');
        // errorlog('Es existiert eine neuere Map. Bitte laden die Sie Seite neu.');
        if(!alert(i18nJson.notifications.error.mapVersionOutdated)) {
            window.location.reload(true);
        }

    } else if(msg.state === 'error-invalid-map-id') {
        // notification.find('span').text('!! Map mit der ID ' + msg.data + ' existiert nicht !!');
        // notification.removeClass('hide');
        // errorlog('Map mit der ID ' + msg.data + ' existiert nicht');
        alert(i18nJson.notifications.error.invalidMapId.replace('[mapId]', msg.data));

    } else {
        // notification.find('span').text('!! Es gab ein Problem – bitte laden Sie die Seite erneut !!');
        // notification.removeClass('hide');
        // errorlog('Es gab ein Problem – bitte laden Sie die Seite erneut:' + msg.data);
        if(!alert(i18nJson.notifications.error.fatal.replace('[errorMessage]', msg.data))) {
            window.location.reload(true);
        }
    }
}

// EVENTLISTENER
// ---------------------------------------------------------------

// UTIL
// ---------------------------------------------------------------
function xhr(data) {
    $.ajax({
        method: usedRequestMethod,
        url: usedApiPath,
        data: data
    })
    .done((msg) => {
        response(msg);
    })
    .fail((xhr, textStatus) => {
        alert('Fataler Error! ' + textStatus);
        errorlog(textStatus);
    });
}

function isDevelopment() {
    return window.location.hostname === 'localhost' && window.location.port !== '5000';
}
